import { Box, Typography, Button, Grid, Card, CardContent } from '@mui/material';
import { FaRocket, FaHeart, FaShareAlt } from 'react-icons/fa';
import COLORS from '../../../../../../constants/colors';

const CampaignFeatures = () => {
  const features = [
    {
      title: 'Launch Your Fundraiser',
      description: 'Start your fundraiser with just a few simple steps.',
      icon: <FaRocket size={24} color={COLORS.primary} />,
    },
    {
      title: 'Contribute to a Cause',
      description: 'Browse and donate to support meaningful causes.',
      icon: <FaHeart size={24} color={COLORS.primary} />,
    },
    {
      title: 'Share and Inspire',
      description: 'Spread the word on social media to amplify impact.',
      icon: <FaShareAlt size={24} color={COLORS.primary} />,
    },
  ];

  return (
    <Box sx={{ textAlign: 'center', py: 8, px: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={4}>
        Join Us in Making a Difference
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
            <Card
              sx={{
                backgroundColor: COLORS.white,
                p: 3,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 5,
                height: '100%',
                textAlign: 'center',
                boxShadow: `0 2px 10px ${COLORS.primary}15`,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  boxShadow: `0 6px 20px ${COLORS.primary}30`,
                },
              }}
            >
              <Box
                sx={{
                  mb: 3,
                  width: 60,
                  height: 60,
                  borderRadius: '50%',
                  backgroundColor: `${COLORS.primary}10`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {feature.icon}
              </Box>

              <CardContent sx={{ px: 2 }}>
                <Typography variant="h6" fontWeight="bold" color={COLORS.primary} sx={{ mb: 1 }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" color={COLORS.text}>
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CampaignFeatures;
